import api from '../api';
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from '../helpers/AppHelpers';
import { browserHistory } from '../browserHistory';
import {
  SET_MAINTENANCE_REQUESTS_FILTER,
  CLEAR_MAINTENANCE_REQUESTS_STATE,
  SET_CURRENT_MAINTENANCE_REQUEST,
  SET_LOAD_MORE_FLAG
} from 'constants/reduceConstants';
import {
  SUCCESS_CREATE_MAINTENANCE_REQUEST,
  SUCCESS_DELETE_MAINTENANCE_REQUEST,
  SUCCESS_UPDATE_MAINTENANCE_REQUEST
} from '../constants/infoSnackbarData';
import {
  MAINTENANCE_REQUEST_DETAILS_PATH,
  MAINTENANCE_REQUEST_SUMMARY_PATH
} from '../constants/routeConstants';

export const getRequestsList = (q) => (dispatch) =>
  api.maintenanceRequest
    .getRequestsListApi(q)
    .then((res) => {
      dispatch({ type: SET_LOAD_MORE_FLAG, payload: false });
      return res;
    })
    .catch((err) => console.log(err));

export const getCreationFrom = (q) => () =>
  api.maintenanceRequest
    .getCreationFromApi(q)
    .then((res) => res)
    .catch((err) => console.log(err));

export const getSingleRequest = (id) => (dispatch) =>
  api.maintenanceRequest
    .getRequestApi(id)
    .then((res) => {
      dispatch({ type: SET_CURRENT_MAINTENANCE_REQUEST, payload: res });
      return res;
    })
    .catch((err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
      browserHistory.push(MAINTENANCE_REQUEST_SUMMARY_PATH);
    });

export const createRequest = (data) => () =>
  api.maintenanceRequest.createRequestApi(data).then(
    (res) => {
      enqueueSuccessSnackbar(SUCCESS_CREATE_MAINTENANCE_REQUEST);
      browserHistory.push(`${MAINTENANCE_REQUEST_DETAILS_PATH}/${res.id}`);
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      return errors;
    }
  );

export const updateRequest = (data) => () =>
  api.maintenanceRequest.updateRequestApi(data).then(
    (res) => {
      enqueueSuccessSnackbar(SUCCESS_UPDATE_MAINTENANCE_REQUEST);
      browserHistory.push(`${MAINTENANCE_REQUEST_DETAILS_PATH}/${res.id}`);
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      return errors;
    }
  );

export const deleteRequest = (id) => () =>
  api.maintenanceRequest.deleteRequestApi(id).then(
    () => {
      enqueueSuccessSnackbar(SUCCESS_DELETE_MAINTENANCE_REQUEST);
      browserHistory.push(MAINTENANCE_REQUEST_SUMMARY_PATH);
    },
    (err) => {
      const errors = JSON.parse(err.request.response);
      enqueueErrorSnackbar('', errors);
    }
  );

export const setFilter = (payload) => (dispatch) =>
  dispatch({ type: SET_MAINTENANCE_REQUESTS_FILTER, payload });

export const clearState = () => (dispatch) => dispatch({ type: CLEAR_MAINTENANCE_REQUESTS_STATE });
